
















































































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import SearchFilter from '@/components/Utilities/SearchFilter.vue';
import { DropDownItem } from "@/services/DropDownItem";
import PpeUserMatrixDetail from '@/components/Ppe/PpeUserMatrixDetail.vue';
import PpeUserMatrixForm from '@/components/Ppe/PpeUserMatrixForm.vue';

interface selectedUser {
    username: string,
    idUser: string,
}

interface Option {
    value?: number
    text: string
}

@Component({
    components: {
        SearchFilter,
        PpeUserMatrixDetail,
        PpeUserMatrixForm
    },
})
export default class PpeUsersMatrixManagement extends Vue {
    ready: boolean = false;
    showLoading: boolean = false;

    // advanced search
    resultsItems: any = {
        resultPage: new Array(),
        total: 0
    };
    page: number = 1;
    firstSearch: boolean = false;
    freeText = null;
    filterSelected: boolean = false;
    advUsernameFilter: string = null;
    advUserTypeFilter: string = null;
    advUserCountryFilter: string = null;

    dropDownCountries: Array<Option> = new Array;
    dropDownUserTypes: Array<Option> = new Array();

    selectedUser: selectedUser = {
        username: '',
        idUser: null,
    };

    get AdvancedSearchFilled(): boolean {
        return this.checkAdvancedSearchFilled();
    }

    async mounted() {
        this.ready = true;
        this.dropDownCountries = await this.getDropdownCountries();
        this.dropDownUserTypes = this.getDropDownUserType();
    }

    async searchUsersMatrixAsync(start: boolean) {
        this.showLoading = true;
        if (start == true) {
            this.resetSearch();
        }
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/ppe/GetUsersWithFilter'),
                data: {
                    FreeText: this.freeText,
                    UserName: this.advUsernameFilter,
                    UserType: this.advUserTypeFilter,
                    IdCountry: this.advUserCountryFilter,
                    CurrentPage: this.page
                },
                withCredentials: true,
                responseType: 'json'
            });
            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;

            this.firstSearch = true;
            this.page += 1;
            this.showLoading = false;

        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }
    }

    async getDropdownCountries(): Promise<Array<any>> {
        try {
            let country: DropDownItem = new DropDownItem();
            let countryList: DropDownItem[] = [];

            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/Culture/GetCountriesAll'), {
                responseType: "json",
                withCredentials: true
            });

            if (response.data) {
                response.data.forEach(element => {
                    country = new DropDownItem();
                    country.idDropDownItem = element.idCountry;
                    country.itemText = element.name;

                    countryList.push(country);
                });
                return General.SetOptionsDropDown(countryList);
            }
        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    getDropDownUserType(): Array<any>{
        let userType: DropDownItem = new DropDownItem();
        let userTypeList: DropDownItem[] = [];

        let usersTypes = [
            {
                name: 'Subsiary',
                value: 'S'
            },
            {
                name: 'Head of Marketing',
                value: 'H'
            },
            {
                name: 'Country Manager',
                value: 'C'
            },
            {
                name: 'Production Manager',
                value: 'R'
            },
            {
                name: 'Country Manager - Industry - Captive / OEM',
                value: 'I'
            },
            {
                name: 'Country Manager - Industry - Non Captive',
                value: 'Y'
            },
            {
                name: 'Country Manager - Industry - All',
                value: 'J'
            },
            {
                name: 'CC Mail Recipient',
                value: 'M'
            }
        ]

        usersTypes.forEach(e => {
            userType = new DropDownItem();
            userType.idDropDownItem = e.value;
            userType.itemText = e.name;

            userTypeList.push(userType);
        })

        return General.SetOptionsDropDown(userTypeList);
    }

    checkSearchFilled() {
        if (!this.checkIsNullOrEmpty(this.freeText)) return true;
        return false;
    }

    checkFilterParameter() {
        if (this.AdvancedSearchFilled)
            this.filterSelected = true;
        else
            this.filterSelected = false;
    }

    checkIsNullOrEmpty(text: any) {
        if (text == null) return true;
        if (text == '') return true;
        return false;
    }

    searchFilterSearchEvent(genericSearch: string) {
        if (genericSearch != null)
            this.freeText = genericSearch;

        this.searchItems(true)
    }

    searchItems(start: boolean) {
        this.searchUsersMatrixAsync(start);
    }

    resetSearch() {
        this.firstSearch = false;
        this.resultsItems.resultPage.splice(0);
        this.page = 1;
    }

    resetFilters() {
        this.advUsernameFilter = null;
        this.advUserTypeFilter = null;
        this.advUserCountryFilter = null;
        this.filterSelected = false;
    }

    checkAdvancedSearchFilled(): boolean {
        if (!this.checkIsNullOrEmpty(this.advUsernameFilter)) return true;
        if (!this.checkIsNullOrEmpty(this.advUserTypeFilter)) return true;
        if (!this.checkIsNullOrEmpty(this.advUserCountryFilter)) return true;
        return false;
    }

    openCreationModal(): void {
        this.$bvModal.show('matrix-form-user-modal');
    }

    openUserDetailsModal(selectedUser: selectedUser) {
        this.selectedUser.idUser = selectedUser.idUser;
        this.selectedUser.username = selectedUser.username

        this.$bvModal.show('user-details-modal');
    }
}
